
export interface OrderPartyDetail {
    id?: string;
    createDate?: string;
    deaNumber: string;
    physicalAddress?: IOrderPartyAddress;
    shippingAddress?: IOrderPartyAddress;
    contactPerson?: IOrderPartyContactPerson;
    orderPartyID?: string;
    orderParty: IOrderParty;
}


export interface IOrderPartyAddress {
    address1: string;
    address2?: string;
    zipCode: string;
    state: string;
    city: string;
}

export interface IOrderPartyContactPerson {
    firstName?: string;
    lastName?: string;
}

export interface IOrderParty {
    id?: string;
    createDate?: string;
    companyName: string;
    pharmacyID?: string;
    type: OrderPartyTypeEnum;
}

export enum OrderPartyTypeEnum {
    Supplier, //plays pharmacy role
    Buyer,
    EdiSupplier,
    EdiBuyer //plays pharmacy role
}
